import styled, { css } from "styled-components"

import Link from "~/components/atoms/Link"
import Pc from "~/components/atoms/Pc"
import Sp from "~/components/atoms/Sp"
import { ContainerLarge } from "~/components/layouts/Container"
import { Color, IsMobile, IsPC, LineHeight, SpacingSize, TextSize, Transition } from "~/consts/style-mixins"
import { staticPath } from "~/services/helper"

import EmploymentFlow from "./EmploymentFlow"

interface Props {
  items?: Item[]
  courseName: string
}

interface Item {
  imgNumberPc: string
  imgNumberSp: string
  heading: string
  description: string
  linkURL?: string
  linkText?: string
}

interface StyledProps {
  messageBorderBottom: boolean
}

const Career = ({ items, courseName }: Props) => {
  return (
    <Container messageBorderBottom={items !== undefined}>
      <Pc>
        <img src={staticPath("/static/images/course/career-pc.svg")} />
      </Pc>
      <Sp>
        <img src={staticPath("/static/images/course/career-sp.svg")} />
      </Sp>
      {items &&
        items.map((item, index) => {
          return (
            <div key={index} className="reference">
              <Pc>
                <img src={item.imgNumberPc} />
              </Pc>
              <Sp>
                <img src={item.imgNumberSp} />
              </Sp>
              <div className="text-wrapper">
                <h2 className="heading">{item.heading}</h2>
                <div className="description-wrapper">
                  <p className="description">{item.description}</p>
                  <Link href={item.linkURL || ""} className="link">
                    {item.linkText}
                  </Link>
                </div>
              </div>
            </div>
          )
        })}
      <EmploymentFlow courseName={courseName} arrowBottomMargin="-265" />
    </Container>
  )
}

const Container = styled(ContainerLarge)`
  ${IsPC(css`
    padding: 96px 16px;
  `)}
  ${IsMobile(css`
    padding: 48px 16px;
  `)}
  .message {
    font-weight: bold;
    line-height: ${LineHeight.M}%;
    white-space: pre-line;
    ${({ messageBorderBottom }: StyledProps) => css`
      ${messageBorderBottom &&
      css`
        border-bottom: solid 1px ${Color.Black};
      `}
    `}
    ${IsPC(css`
      font-size: 20px;
      padding: 48px 0;
    `)}
    ${IsMobile(css`
      font-size: 16px;
      padding: 32px 0;
    `)}
  }
  .reference {
    display: flex;
    ${IsPC(css`
      margin-top: 48px;
    `)}
    ${IsMobile(css`
      margin-top: 32px;
    `)}
  }
  .text-wrapper {
    display: block;
    ${IsMobile(css`
      flex-direction: column;
    `)}
  }
  .heading-wrapper {
    display: flex;
  }
  .heading {
    min-width: 280px;
    font-size: ${TextSize.L}px;
    font-weight: bold;
    line-height: ${LineHeight.S}%;
    margin-left: ${SpacingSize.M}px;
  }
  .description-wrapper {
    margin-left: ${SpacingSize.M}px;
  }
  .description {
    font-size: ${TextSize.M}px;
    line-height: ${LineHeight.L}%;
    color: ${Color.Gray};
    ${IsMobile(css`
      margin-top: 8px;
    `)}
  }
  .link {
    display: inline-block;
    color: ${Color.Secondary};
    line-height: ${LineHeight.M}%;
    margin-top: ${SpacingSize["3XS"]}px;
    &:hover {
      color: ${Color.SecondaryDark};
      text-decoration: underline;
      ${Transition.Hover};
    }
  }
`

export default Career
